export default __webpack_public_path__ + "static/media/userf-4.5b62db85.jpg";